import m from "../../geodata/es2015/saintVincentLow";
window.am4geodata_saintVincentLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/saintVincentLow.js
// module id = null
// module chunks = 